export enum SelectStatementType {
  NONE = 'NONE',
  ALL = 'ALL',
  DSL = 'DSL',
  SQL = 'SQL',
}
